import Row from '@components/Row';
import Text from '@components/Text';
import { Fragment, useMemo, useState } from 'react';

import BottomSheet from './BottomSheet';
import DropdownIcon from './DropdownIcon';
import styles from './styles.module.scss';

interface Props {
    title: string;
    options?: {value: string; label: string}[];
    value?: string;
    onChange?: (v: string) =>void;
}

function FilterOption({
    title, value, options, onChange,
}:Props) {
    const [isOpen, setIsOpen] = useState(false);
    const displayValue = useMemo(() => {
        if (value) {
            return options?.find((option) => option.value === value)?.label;
        }
        return title;
    }, [title, value, options]);
    return (<Fragment>
        <Row onClick={() => setIsOpen(true)}
            className={styles.container}
            fullWidth
            justify='space-between'
            align='center'
            spacing={7} >
            <Text fontWeight='bold'>
                {displayValue}
            </Text>
            <DropdownIcon/>
        </Row>
        <BottomSheet isOpen={isOpen}
            options={options}
            onChange={onChange}
            close={() => setIsOpen(false)}
            title={title} />
    </Fragment>);
}

export default FilterOption;
